const THIRD_PARTY = {
  IFRAME_PERMISSIONS:
    'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
  /**
   * For reference around params
   * See: https://developers.google.com/youtube/player_parameters#Parameters
   */
  YT_PARAMS: '?modestbranding=1&autoplay=1',
};

export default THIRD_PARTY;
